@if (content) {
    <div class="product-menu-content">
        @for (section of content | dsl | async; track trackByProp($index, section)) {
            <ng-container *vnDynamicComponent="getItemComponent(section.type); attr: { item: section }" />
        }
    </div>
}
